import { Draft } from '@reduxjs/toolkit';

import { IAuthData } from '../../initialState';

function editCompanyFailure(draft: Draft<IAuthData>) {
  draft.editCompany.config.isLoading = false;
}

export default editCompanyFailure;
